/*
 * Get any applications that the current user has access to (with role data)
 */
import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default (state: RootState): string[] => {
  return state.auth?.user?.account?.permissions || EMPTY_ARRAY;
};
